import logo from "assets/images/logo-bn.png";
import logo7Eleven from "assets/images/logo7Eleven.png";
import logoFarmacias from "assets/images/logoFarmacias.png";
import logoChedraui from "assets/images/logoChedraui.png";
import logoYastas from "assets/images/logoYastas.png";
import logoDelSol from "assets/images/logoDelSol.png";
import logoWoolworth from "assets/images/logoWoolworth.png";
import logoFinanciera from "assets/images/logoFinanciera.png";
import flow from "lodash/flow";
import { Children } from "react";
import { LightButton } from "../../../../components/buttons/buttons";
import Modal from "../../../../components/modals/modal/modal";
import { currencyFormat, nullary } from "../../../../core/utils";
import { ModalProps } from "../../../../core/utils/modals";
import { DatosReferencia } from "../types/pagos.types";
import "./referencia-cep.modal.scss";

export type ReferenciaCepModalProps = ModalProps & {
	datos?: Partial<DatosReferencia>
	descargarReferencia: VoidFunction;
};

const ReferenciaCepModal = ({ parent, datos = {}, descargarReferencia }: ReferenciaCepModalProps) => {
	const footer = (close: VoidFunction) => (
		<>
			<LightButton className="me-5" onClick={nullary(flow(descargarReferencia, close))}>Descargar</LightButton>
			<LightButton className="ml-5" onClick={nullary(flow(window.print, close))}>Imprimir</LightButton>
		</>
	);

	return (
		<Modal parent={parent} title="" dialogClassName="referencia-cep" footer={footer}>
			<div className="col-12" >
				<div className="comprobante-banorte">
					<div className="c-header">
						<img src={logo} alt="alt" height="60px" />
					</div>
					<div className="c-body">
						<div className="c-b-success">
							<div className="e-title">
								<span>Vas a realizar un pago por</span>
							</div>
							<div className="e-subtitle">
								<span>{currencyFormat(datos.importe ?? 0)} MN</span>
							</div>
						</div>
						<div className="row">
							<div className="col-12">
								<table>
									<tbody>
										<tr>
											<td>Cliente:</td>
											<td>{datos.nombre}</td>
										</tr>
										<tr>
											<td>ID de cliente:</td>
											<td>{datos.idCliente}</td>
										</tr>
										<tr>
											<td>Concepto:</td>
											<td>
												{Children.toArray(datos.conceptos?.map(concepto =>
													<>{concepto}<br /></>
												))}
											</td>
										</tr>
										<tr>
											<td>Importe:</td>
											<td>{currencyFormat(datos.importe ?? 0)} MN</td>
										</tr>
									</tbody>
								</table>
								<hr />
								<table>
									<tbody>
										<tr>
											<td>Emisora:</td>
											<td>{datos.emisora}</td>
										</tr>
										<tr>
											<td>Referencia:</td>
											<td>{datos.referencia}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div className="c-b-success">
							<div className="e-title">
								<span>Para realizar el pago de servicios, presenta esta información en cualquiera de nuestras corresponsalías. Conoce cuáles son aquí.</span>
								<br></br>
								<img src={logo7Eleven} alt="alt" height="65px" />&nbsp;&nbsp;
								<img src={logoFarmacias} alt="alt" height="70px" />
								<img src={logoChedraui} alt="alt" height="50px" />
								<img src={logoYastas} alt="alt" height="50px" />
								<img src={logoDelSol} alt="alt" height="65px" />	&nbsp;
								<img src={logoWoolworth} alt="alt" height="15px" />&nbsp;
								<img src={logoFinanciera} alt="alt" height="80px" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default ReferenciaCepModal;